// export const value = state => {
//     return state.value;
//   }

let getters = {};

export default getters;